export default __webpack_public_path__ + "static/media/q26_step4.6bd16b88.png";